<template>
  <div class="message-body" :class="[senderType == 'user' ? 'color-theme-default' : '']">
    <audio id="song" width="200" height="10" controls="controls">
      <source :src="audio.url | absURL" :type="audio.mimetype">
    </audio>
  </div>
</template>

<script>
export default {
  props: ['audio', 'senderType']
}
</script>
